/**
@format
@flow
*/
import * as React from 'react';
import HeadlineDefault from './HeadlineDefault';
import type { Props as HeadlineDefaultProps } from './HeadlineDefault';
import HeadlinePage from './HeadlinePage';
import type { Props as HeadlinePageProps } from './HeadlinePage';

export type HeadlineDefaultType = {|variant: 'default', ...HeadlineDefaultProps|};
export type HeadlinePageType = {|variant: 'page', ...HeadlinePageProps|};

export type HeadlineType = HeadlineDefaultType | HeadlinePageType;

const Headline: React$ComponentType<HeadlineType> = (props: Object): React$Node => {
  const {
    variant,
    ...rest
  } = props;

  switch (variant) {
  case 'page':
    return <HeadlinePage {...rest} />;
  case 'default':
  default:
    return <HeadlineDefault {...rest} />;
  }
};

export default Headline;
